/**
 * Firebase web (publishable) configuration for push notifications.
 *
 * Every value here is a *publishable* client credential — Firebase intends
 * these to live in client code. The only private credential is the service
 * account JSON, which is stored as the FIREBASE_SERVICE_ACCOUNT secret and used
 * server-side (see src/lib/push/fcm.server.ts).
 *
 * Values are read from VITE_ env vars when present, with literal fallbacks so
 * the config also works once pasted directly. Fill these in with the values
 * from your Firebase project (Project settings -> General -> Your apps -> Web).
 */
export const firebaseConfig = {
  apiKey:
    import.meta.env.VITE_FIREBASE_API_KEY ||
    "AIzaSyAlz3ji_P1tTTi1IvOsxafF1GCpj7WkvwA",
  authDomain:
    import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ||
    "digitally-baffled.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "digitally-baffled",
  messagingSenderId:
    import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "1077524856710",
  appId:
    import.meta.env.VITE_FIREBASE_APP_ID ||
    "1:1077524856710:web:343738760f6a057b1d3607",
};

/** Web Push certificate key pair (Cloud Messaging -> Web configuration). */
export const vapidKey =
  import.meta.env.VITE_FIREBASE_VAPID_KEY ||
  "moVRSyye4ugffIoR19FH4tcBF4JcHDrbLQ-rkG7mIeg";

/** True once a real Firebase project has been wired up. */
export const isPushConfigured = Boolean(
  firebaseConfig.projectId && firebaseConfig.appId && vapidKey,
);
